import { render } from "./StickerEngineComponent.vue?vue&type=template&id=72d61680"
import script from "./StickerEngineComponent.vue?vue&type=script&scope=true&lang=js"
export * from "./StickerEngineComponent.vue?vue&type=script&scope=true&lang=js"

import "./StickerEngineComponent.vue?vue&type=style&index=0&id=72d61680&scope=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__